import React, { memo } from "react";

import Presentation from "./presentation";

const component = props => {

	return (
		<Presentation
			{ ...props }
		/>
	);
};

export default memo ( component );
